import React from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";

const ModalCreateTemplates = ({
  showModalCreateTemplates,
  handleCloseModalCreateTemplates,
  handleCreateTemplate,
  formDataTemplates,
  handleInputChangeTemplates,
  loadingTemplates,
  templateModalErrors,
  flavorsList,
}) => {
  return (
    <Modal
      show={showModalCreateTemplates}
      onHide={handleCloseModalCreateTemplates}
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>Create New Template</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={(e) => e.preventDefault()}>
          <Form.Group controlId="name" style={{ marginBottom: "12px" }}>
            <Form.Label>
              Name <span style={{ color: "red" }}>*</span>
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Add a template name"
              name="name"
              value={formDataTemplates?.name || ""}
              onChange={handleInputChangeTemplates}
            />
            {templateModalErrors?.name && (
              <div
                style={{ fontSize: "0.8em", fontStyle: "italic", color: "red" }}
              >
                {templateModalErrors.name}
              </div>
            )}
          </Form.Group>

          <Form.Group controlId="description" style={{ marginBottom: "12px" }}>
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              placeholder="Add some personal notes"
              name="description"
              rows={3}
              value={formDataTemplates?.description || ""}
              onChange={handleInputChangeTemplates}
              style={{ resize: "vertical" }}
            />
          </Form.Group>

          <Form.Group controlId="flavor" style={{ marginBottom: "12px" }}>
            <Form.Label>Flavor</Form.Label>
            <Form.Control
              as="select"
              name="flavor"
              value={formDataTemplates?.flavor || ""}
              onChange={handleInputChangeTemplates}
            >
              <option value="">Select a flavor</option>
              {flavorsList?.map((flavor, index) => (
                <option key={index} value={flavor.name || ""}>
                  {flavor.name || ""}
                </option>
              ))}
            </Form.Control>
          </Form.Group>

          <Form.Group controlId="disk" style={{ marginBottom: "12px" }}>
            <Form.Label>Disk</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter disk"
              name="disk"
              value={formDataTemplates?.disk || ""}
              onChange={handleInputChangeTemplates}
            />
          </Form.Group>

          <Form.Group controlId="backing_file" style={{ marginBottom: "12px" }}>
            <Form.Label>Backing File</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter backing file"
              name="backing_file"
              value={formDataTemplates?.backing_file || ""}
              onChange={handleInputChangeTemplates}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-between align-items-center">
        <small className="text-danger">
          The fields marked with "*" are required
        </small>

        <div>
          <Button variant="secondary" onClick={handleCloseModalCreateTemplates}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleCreateTemplate}
            disabled={loadingTemplates}
            className="ms-2"
          >
            {loadingTemplates ? (
              <Spinner animation="border" size="sm" />
            ) : (
              "Save Template"
            )}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalCreateTemplates;
